var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-overlay',{staticStyle:{"z-index":"1111"},attrs:{"show":_vm.show}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","height":"100%"}},[_c('van-loading',{attrs:{"size":"24px","vertical":"","color":"#ffffff"}},[_vm._v(_vm._s(_vm.title))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9beea41e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/loading/loading.vue
// module id = null
// module chunks = 